import { render, staticRenderFns } from "./payslipfilter.vue?vue&type=template&id=bdffd6c2"
import script from "./payslipfilter.vue?vue&type=script&lang=js"
export * from "./payslipfilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports